<template>
  <v-menu offset-y :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-icon
        color="white"
        v-on="on"
        @click="getList(field)"
        style="font-size: 15px !important"
        >mdi-filter-outline</v-icon
      >
    </template>
    <v-card width="185px">
      <v-list class="blackFont--text">
        <template v-if="!isNotSort">
          <v-list-item
            @click="sortBy('asc')"
            :title="
              field.includes('date')
                ? 'Oldest to Newest'
                : columnType
                ? 'Smallest to Largest'
                : 'A to Z'
            "
          >
            <v-list-item-title
              ><img src="@/assets/images/icon/asc.png" /><span
                class="blackFont--text font-weight-medium"
              >
                Sort
                {{
                  field.includes('date')
                    ? 'Oldest to Newest'
                    : columnType
                    ? 'Smallest to Largest'
                    : 'A to Z'
                }}
              </span></v-list-item-title
            >
          </v-list-item>
          <v-list-item
            @click="sortBy('desc')"
            :title="
              field.includes('date')
                ? 'Newest to Oldest'
                : columnType
                ? 'Largest to Smallest'
                : 'Z to A'
            "
          >
            <v-list-item-title
              ><img src="@/assets/images/icon/desc.png" /><span
                class="blackFont--text font-weight-medium"
              >
                Sort
                {{
                  field.includes('date')
                    ? 'Newest to Oldest'
                    : columnType
                    ? 'Largest to Smallest'
                    : 'Z to A'
                }}
              </span></v-list-item-title
            >
          </v-list-item>
        </template>
        <v-flex xs12 class="px-3 py-2">
          <v-text-field
            outlined
            single-line
            rounded
            v-model="search"
            hide-details
            placeholder="Search"
            prepend-inner-icon="search"
            class="py-0 dashSearch mb-2 mt-2"
          ></v-text-field>
          <v-progress-linear
            color="primary"
            indeterminate
            rounded
            height="6"
            v-if="isLoading"
          ></v-progress-linear>
          <VuePerfectScrollbar
            class="drawer-menu--scroll-filter"
            :settings="scrollSettings"
          >
            <template v-for="(list, indexList) in listFilter">
              <v-checkbox
                v-if="list !== 'null' && list !== '0'"
                v-model="selected"
                :label="columnType ? idrFilter(list) : list"
                :value="list"
                hide-details
                :key="'list-' + indexList"
                :class="
                  field === 'status'
                    ? 'text-uppercase filter-checkbox filter-ceklis pa-0 mt-2'
                    : 'filter-checkbox filter-ceklis pa-0 mt-2'
                "
              ></v-checkbox>
            </template>
          </VuePerfectScrollbar>
          <!-- <v-row v-if="listFilter.length === 1 && listFilter[0] === '0'">
          </v-row> -->
          <v-row class="px-3">
            <v-flex xs12 class="pa-0">
              <hr class="hr-line" />
            </v-flex>
            <v-btn
              small
              color="primary"
              class="mr-2 fs-12 px-4"
              @click="filtered('submit')"
              >Filter</v-btn
            >
            <v-btn small outlined class="fs-12 px-4" @click="filtered('clear')"
              >Reset</v-btn
            >
          </v-row>
        </v-flex>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Swal from 'sweetalert2';
import moment from 'moment';

export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    field: {
      type: String,
      required: false
    },
    indexItem: {
      type: Number,
      required: true
    },
    columnType: {
      type: Boolean,
      required: false
    },
    // listFilter: {
    //   type: Array,
    //   required: false
    // },
    isNotSort: {
      type: Boolean,
      required: false
    },
    year: {
      type: Date,
      required: true
    },
    isNonPO: {
      type: Boolean,
      required: false,
      default: false
    },
    paramFiltered: {
      type: Array,
      require: true
    }
  },
  data() {
    return {
      search: '',
      timeout: null,
      selected: [],
      scrollSettings: {
        maxScrollbarLength: 260
      },
      listFilter: [],
      isLoading: false
    };
  },
  mounted() {
    // this.filtered('clear');
  },
  watch: {
    search() {
      this.selected = [];
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$emit('searchColumn', {
          fieldName: this.field,
          value: this.search,
          index: this.indexItem
        });
      }, 1000);
    }
  },
  methods: {
    sortBy(val) {
      this.$emit('sortBy', {
        fieldName: this.field,
        value: val,
        index: this.indexItem
      });
    },
    filtered(type) {
      this.selected = type === 'clear' ? [] : this.selected;
      this.search = type === 'clear' ? '' : this.search;
      // this.$emit('filterItem', {
      //   fieldName: this.field,
      //   value: type === 'submit' ? this.selected : '',
      //   tableIndex: this.indexItem
      // });
      this.$emit('checkColumn', {
        fieldName: this.field,
        value: this.selected,
        index: this.indexItem,
        type
      });
    },
    getList(val) {
      this.isLoading = true;
      let apiName = '';
      if (this.isNonPO) {
        apiName = 'purchasingOrder/getFilteredNonPO';
      } else {
        apiName = 'purchasingOrder/getFilteredPO';
      }
      return this.$store
        .dispatch(apiName, {
          year: moment(this.year).format('YYYY'),
          field: val,
          filter: this.paramFiltered
        })
        .then(data => {
          this.isLoading = false;
          this.listFilter = [];
          if (data.code === 200) {
            if (val.includes('date')) {
              this.listFilter = data.data.map(item => {
                return item === null ? '-' : moment(item).format('YYYY-MM-DD');
              });
            } else {
              this.listFilter = data.data;
            }
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.isLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    }
  }
};
</script>
<style>
.v-list-item {
  min-height: 30px !important;
}

.filter-checkbox.v-input--selection-controls .v-input__slot > .v-label {
  color: #333 !important;
}

.filter-ceklis,
.v-text-field input,
.v-label {
  font-size: 12px !important;
}

.drawer-menu--scroll-filter {
  max-height: 150px;
  overflow: auto;
}
</style>
